import { Flex } from '@common/components/Flex';
import { QuestionIcon } from '@common/components/question-icon';

import './question-message.styles.scss';

export const QuestionMessage = (props) => {
	const { children } = props;

	return (
		<Flex className="QuestionMessage">
			<QuestionIcon margin="0 8px 0 0" />
			<div className="QuestionMessage__children">{children}</div>
		</Flex>
	);
};